import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { FaqService } from 'src/app/services/faq.service';
import { OverlayService } from 'src/app/services/overlay.service';

@Component({
  selector: 'app-add-faq',
  templateUrl: './add-faq.component.html',
  styleUrls: ['./add-faq.component.scss']
})
export class AddFAQComponent implements OnInit {
  /**
   * The Form to add a FAQ
   */
  addForm: UntypedFormGroup;
/**
 * constructor
 * init the Form
 * @param faq 
 * @param fb 
 * @param overlayService 
 * @param router 
 */
  constructor(
    private faq: FaqService,
    private fb: UntypedFormBuilder,
    private overlayService:OverlayService,
    private router:Router) {
    this.addForm = this.fb.group({
      title: ['', [Validators.required]],
      description: ['', [Validators.required]]
    })
  }
/**
 * ngOnInit
 */
  ngOnInit(): void {

  }
  /**
   * create a FAQ
   * @returns 
   */
  createFAQ() {
    this.addForm.markAllAsTouched();
    if(this.addForm.invalid){
      return;
    }
    let faq = {
      "title": this.addForm.value.title,
      "description": this.addForm.value.description,
    }
    this.faq.createFAQ(faq).subscribe(newFAQ=>{
      if(newFAQ){
        this.overlayService.openSnackBar("FAQ-Eintrag erfolgreich angelegt!");
        this.router.navigate(["caseworker/faq"]);
      } 
    })
  }
}
